import React from 'react';
import { compose, withProps } from 'recompose';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps';
import styled from 'styled-components';

const Wrapper = styled.section`
  height: 300px;
`;

const GoogleMaps = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${
      process.env.GATSBY_GOOGLE_MAPS_API
    }&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `300px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap,
)(({ isMarkerShown }) => (
  <Wrapper>
    <GoogleMap
      defaultZoom={17}
      defaultCenter={{ lat: 16.5717583, lng: 120.3209568 }}
    >
      {isMarkerShown && (
        <Marker position={{ lat: 16.5716583, lng: 120.3211468 }} />
      )}
    </GoogleMap>
  </Wrapper>
));

export default GoogleMaps;
